import { Checkbox } from "@/components/ui/checkbox";

export const WORK_TYPES = ["Operazioni cimiteriali", "Pulizia bagni", "Raccolta rifiuti", "Pulizia viali", "Taglio erba"];
const slug = (s) => s.toLowerCase().replace(/\s+/g, "-");

export const applyWorkTypes = (f, v) => {
  const prev = (f.work_types || []).join(", ");
  const auto = !f.title.trim() || f.title === prev || v.length > (f.work_types || []).length;
  return { ...f, work_types: v, title: auto ? v.join(", ") : f.title };
};

export const WorkTypeChecks = ({ value = [], onChange, testid = "order-form-work-type" }) => (
  <div className="-mt-2 flex flex-wrap gap-2 sm:col-span-2" data-testid={`${testid}s`}>
      {WORK_TYPES.map((w) => (
        <label key={w} className="flex cursor-pointer items-center gap-2 rounded-xl border bg-white px-3 py-2 text-sm font-medium transition-colors hover:bg-accent">
          <Checkbox checked={value.includes(w)} onCheckedChange={(c) => onChange(c ? WORK_TYPES.filter((x) => x === w || value.includes(x)) : value.filter((x) => x !== w))}
            data-testid={`${testid}-${slug(w)}`} />
          {w}
        </label>
      ))}
  </div>
);
